import { MouseEvent } from 'react';

/**
 * Use for quick stop propagation of an event.
 * Useful for scenarios where we want to just have single behaviour without the hassle
 * of anonymous functions or bounded methods.
 */
export const stopPropagationHandler = (e: MouseEvent) => {
  e.stopPropagation();
};
